import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import logPage from "../../utils/analytics";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    logPage(pathname)
  }, [pathname]);

  return null;
}